import request from '@/utils/request'

export function getUserInfo(params) {
  return request({
    url: 'self/',
    method: 'get',
    params
  })
}
export function login(data) {
  return request({
    url: 'login/',
    method: 'post',
    data
  })
}
export function logout(data) {
  return request({
    url: 'logout/',
    method: 'get',
    data
  })
}
